import { render, staticRenderFns } from "./RelbaseProductBillingReport.vue?vue&type=template&id=bbd06d86&scoped=true&"
import script from "./RelbaseProductBillingReport.vue?vue&type=script&lang=js&"
export * from "./RelbaseProductBillingReport.vue?vue&type=script&lang=js&"
import style0 from "./RelbaseProductBillingReport.vue?vue&type=style&index=0&id=bbd06d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd06d86",
  null
  
)

export default component.exports